import React from 'react';
import PropTypes from 'prop-types';
import {
  FormattedMessage,
} from 'react-intl';

import {
  Button,
} from '@folio/stripes/components';

import {
  RECORD_LINK_INITIAL_VALUES,
  RECORD_LINKAGE_PAGE_TYPES,
} from '../../../../../../constants';

const addRecordLinkageButton = (fields) => () => fields.push(RECORD_LINK_INITIAL_VALUES);

const AddRecordLinkageButton = ({
  pageType,
  fields,
}) => {
  return (
    <Button
      data-test-add-record-linkage-button
      marginBottom0
      buttonStyle="default"
      id="add-record-linkage-button"
      onClick={addRecordLinkageButton(fields)}
    >
      <FormattedMessage id={`ui-task-list.recordLinkage.addRecordLinkageButton.${pageType}`} />
    </Button>
  );
};

AddRecordLinkageButton.propTypes = {
  fields: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  pageType: PropTypes.oneOf(RECORD_LINKAGE_PAGE_TYPES).isRequired,
};

export default AddRecordLinkageButton;
